<template>
    <BootstrapDialog title="添加回放" ref="dialog" size="lg" @afterClose="afterClose()">
        <template v-slot:body>
            <div class="modal-body wrapper-lg">
                <div class="row">
                    <div class="col-sm-8 col-sm-offset-2">

                        <form role="form">
                            <div class="form-group">
                                <label><span style="color: red">*</span>回放地址</label>
                                <input type="text"  v-model="model.hkdza" name="hkdza" v-validate="{required:true}" data-vv-as="回放地址" class="form-control" placeholder=""/>
                                <span class="error_validate_msg"><em>{{ errors.first('hkdza') }}</em></span>
                            </div>

                            <div class="form-group">
                                <label><span style="color: red">*</span>回放时间(秒)</label>
                                <input type="text"  v-model="model.hkspsc" name="hkspsc" v-validate="{required:true,max:50}" data-vv-as="回放时间" class="form-control" placeholder=""/>
                                <span class="error_validate_msg"><em>{{ errors.first('hkspsc') }}</em></span>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <button class="btn btn-primary" type="button" @click="save()">保存</button>
            <button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
        </template>

    </BootstrapDialog>
</template>
<script>

  /**
   * 添加回放
   */
  export default {
    name:'ZhiboTjhfAdd',
    data:function(){
      return {
        model:{
          // 回放地址
          hkdza: '',
          // 回放时间
          hkspsc: ''
        }
      }
    },
    methods:{
      reset:function(){
        this.model = {
          id:'',
          // 回放地址
          hkdza: '',
          // 回放时间
          hkspsc: ''
        };
      },
      open:function(params){
        this.model.id = params.zbId;
        this.$refs.dialog.open();
      },
      close:function(){
        this.$refs.dialog.close();
      },
      afterClose:function(){
        this.$validator.reset();
        this.reset();
      },
      save:function(){
        this.$validator.validateAll().then((result) => {
          if (result) {//如果表单校验通过才可以保存
            this.$http.post('/htgl/biz/zypx/zb/tjhf',this.model).then(res=>{
              if(res.data){
                this.$success('操作成功',()=>{
                  this.close();
                  this.$parent.search();//刷新列表
                });
              }
            });
          }
        });
      }
    }
  }
</script>
